import { defineMessages } from 'react-intl';

export const upsellProductMessages = defineMessages({
  oneClickA11yLabel: {
    defaultMessage: 'Add 1 {product_name} to your bag',
    description: 'Upsell Product | One-click add to bag a11y label',
  },
});
